import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { BeneficiariesList, Beneficiary, BeneficiaryCard } from "src/app/models/beneficiary";
import { TableColumn } from "src/app/models/table";
import { BeneficiariesService } from "src/app/services/beneficiaries.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogBeneficiariesComponent } from "src/app/components/shared/dialog/beneficiaries.component";
import { TextType } from "src/app/constants/text-type";
import { ContentHeaderKey } from "src/app/constants/content-header";


@Component({
    selector: "mwp-beneficiaries",
    templateUrl: "./beneficiaries.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class BeneficiariesComponent implements OnInit {
    public apiUrl = ContentHeaderKey.EnrollmentBeneficiaries;
    public beneficiarycards: BeneficiaryCard[];
    public isLoaded: boolean;
    public beneficiariesList: BeneficiariesList;

    public beneficiaryCardColumns: TableColumn[] = [
        {
            columnName: 'Beneficiary Type',
            propertyId: 'beneficairyType',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Name',
            propertyId: 'name',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Relationship',
            propertyId: 'relationship',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Percentage',
            propertyId: 'percentage',
            columnType: TableColumnType.label,
            textType: TextType.percent
        },
    ];

    constructor(
        private beneficiariesService: BeneficiariesService,
        public dialog: MatDialog,
    ) { }

    ngOnInit(): void {
        this.loadCards();
    }

    private loadCards(): void {
        this.isLoaded = false;
        this.beneficiariesService.getBeneficiaryList().subscribe((response: BeneficiariesList) => {
            this.beneficiariesList = response;
            const l_beneficiaryCards: BeneficiaryCard[] = response.beneficiaryCards;
            l_beneficiaryCards.forEach((bc: BeneficiaryCard) => {
                bc.beneficiariesForDisplay.forEach((beneficiary: Beneficiary) => {
                    if (beneficiary.isPrimary == true) { beneficiary.beneficairyType = "PRIMARY"; } else {
                        beneficiary.beneficairyType = 'CONTINGENT';
                    };
                });
            });
            this.beneficiarycards = l_beneficiaryCards;
            this.isLoaded = true;
        });
    }

    public getDataTable(beneficiaryCard: BeneficiaryCard): MatTableDataSource<Beneficiary> {
        const l_DataTable = new MatTableDataSource<Beneficiary>();
        l_DataTable.data = beneficiaryCard?.beneficiariesForDisplay;

        return l_DataTable;
    }

    public addModifyOpen(beneficiaryCard: BeneficiaryCard): void {
        let dialogRef = this.dialog.open(DialogBeneficiariesComponent, {
            data: {
                beneficiaryCard: beneficiaryCard,
                beneficiariesList: this.beneficiariesList
            }, panelClass: 'mwp-modal-override-1300'
        });
        dialogRef.afterClosed().subscribe(() => {
            this.loadCards();
        });
    };
}